import { render, staticRenderFns } from "./prospect-list.vue?vue&type=template&id=1cbf47fd"
import script from "./prospect-list.vue?vue&type=script&lang=js"
export * from "./prospect-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports